<div>
  <app-simple-search-select-value-accessor label="Grupa zlecającego"
                                           [formControl]="groupForm"
                                           [searchFunction]="groupSearchFunction"
                                           [findById]="groupFindByIdFunction"
                                           minLength="0"
  >
  </app-simple-search-select-value-accessor>
</div>
